import React from 'react';
export function CaretIcon(props) {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...props },
        React.createElement("path", { d: "M6 9L12 15L18 9", stroke: "#304FFE", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
}
//# sourceMappingURL=CaretIcon.js.map